import React, { Component } from 'react';
import { connect } from 'react-redux';
import {Helmet} from 'react-helmet';
import { map, sumBy } from 'lodash';
import { Link } from 'react-router-dom';
import ConfirmClick from '../../components/common/ConfirmClick';
import Spinner from '../../components/common/Spinner';
import ReactTable from 'react-table';
import selectTableHOC from "react-table/lib/hoc/selectTable";
import { importsActions } from '../../data/actions/imports';
import dynamicColumns from '../../components/common/Datagrid/DynamicColumns';
import CSV from '../../helpers/CSVExport';

var downloadSvg = require('!svg-inline-loader!../../../public/img/download.svg');

class ValidateStatements extends Component {
	constructor(props) {
		super(props);
		this.state = {
		}
		this.exportToCsv = this.exportToCsv.bind(this);
		this.approve = this.approve.bind(this);
	}
	
	componentDidMount() {
		const { match, dispatch, period } = this.props;
		this.props.dispatch(importsActions.getValidateStatements(period));
		this.setState({
			period
		})
	}
	
	approve(){
		const { period, dispatch } = this.props;
		dispatch(importsActions.approveSalesData(period)).then(()=>this.props.history.push('/import/reports'));
	}
	
	exportToCsv(){
		const { period } = this.state;
		let { validatedStatements } = this.props.imports;
		const filename = CSV.CSVHeader('validate_statements', period);
		return CSV.CSVExport(validatedStatements, {filename}, 'validate_statements');
	}
	
	render() {
		const { validatedStatementsLoading, validatedStatements} = this.props.imports,
			{ accepted } = this.props,
			rows = Array.isArray(validatedStatements) ? validatedStatements.length : null;
		
		return <div className="inner-page shared-pages">
			<div className="container">
			
				<h2>Validate Statements
				<a title="Export" onClick={()=>this.exportToCsv()} className="chart-icon download-link" dangerouslySetInnerHTML={{__html: downloadSvg}} />
				
				{!accepted && <ConfirmClick confirmAction={this.approve} title="Publish" confirmClass="btn btn-primary" confirmLabel={'Publish'} confirmPrompt={`Are you sure you want to publish a report for ${this.props.period}`}></ConfirmClick>}
				{accepted && <span>Period already imported!</span>}


				</h2>
				<div className="ibox">
					<ReactTable
						data={validatedStatements}
						loading={validatedStatementsLoading}
						columns={dynamicColumns(validatedStatements, ['label', 'reason_for_concern'])}
						pageSize={rows ? Math.min(rows, 10): 10}
						showPagination={rows > 10}
						className="simple-table share-table"
					/>
				</div>
			</div>
			<Helmet>
				<title>Validate Statements</title>
			</Helmet>

		</div>
	}
}

function mapStateToProps(state) {
	return {
		imports: state.imports
	} 
}

export default connect(mapStateToProps)(ValidateStatements)